import * as moment from 'moment';
import { ValidationErrors } from 'ngrx-forms';

export interface DateLessThanError {

    comparand: string;
    actual: string;
    allowEqual: boolean;
}
export interface DateGreaterThanError {

    comparand: string;
    actual: string;
    allowEqual: boolean;
}

declare module 'ngrx-forms/src/state' {
    export interface ValidationErrors {
        dateLessThan?: DateLessThanError;
        dateGreaterThan?: DateGreaterThanError;
    }
}

export function dateLessThan(comparand: string, allowEqual = false): (value: string) => ValidationErrors {
    return (value: string): ValidationErrors => {
        const err = {
            dateLessThan: {
                comparand: moment(comparand).format('L'),
                actual: moment(value).format('L'),
                allowEqual
            }
        };

        let valid = true;
        if (value && comparand) {
            const diff = moment(value).startOf('d').diff(moment(comparand).startOf('d'));
            if (diff < 0) {
                valid = true;
            } else if (diff === 0) {
                valid = allowEqual;
            } else {
                valid = false;
            }
        }
        if (!valid) {
            return err;
        }
        return {};
    };
}

export function dateGreaterThan(comparand: string, allowEqual = false): (value: string) => ValidationErrors {
    return (value: string): ValidationErrors => {
        const err = {
            dateGreaterThan: {
                comparand: moment(comparand).format('L'),
                actual: moment(value).format('L'),
                allowEqual
            }
        };

        let valid = true;
        if (value && comparand) {
            const diff = moment(value).startOf('d').diff(moment(comparand).startOf('d'));
            if (diff > 0) {
                valid = true;
            } else if (diff === 0) {
                valid = allowEqual;
            } else {
                valid = false;
            }
        }
        if (!valid) {
            return err;
        }
        return {};
    };
}
